export default __webpack_public_path__ + "static/media/awareness.c681c5d1.png";